//
// Module for the ContactInformation Index view
//
rs.module("framework/content/paycomponents/edit",

    ["common/select-helper", "common/visibility", "controls/data/grid"],

    function (selectHelper, visibility, gridModule) {
        //
        // Initialize the module
        //
        function initialize(balanceParametersGridLrsApi, jsSelectors, fundKey, backendUrls, codeValues) {
            var payComponentForm = $.js(jsSelectors.payComponentForm);
            var payComponentType = payComponentForm.js(jsSelectors.payComponentType);
            var payComponent = payComponentForm.js(jsSelectors.payComponent);
            var payComponentSelectHelper = selectHelper.getHelper(payComponent);
            var componentAmount = payComponentForm.js(jsSelectors.componentAmount);
            var componentPercent = payComponentForm.js(jsSelectors.componentPercent, { required: false });
            var standardWarning = payComponentForm.js(jsSelectors.standardWarning);
            var standardWarningPlaceholder = payComponentForm.js(jsSelectors.standardWarningPlaceholder);
            var vendorSelect = payComponentForm.js(jsSelectors.vendorSelect);
            var vendorSelectHelper = selectHelper.getHelper(vendorSelect);
            var vendorSelectHidden = payComponentForm.js(jsSelectors.vendorSelectHidden);
            var applyPriorToTaxFlag = payComponentForm.js(jsSelectors.applyPriorToTaxFlag);
            var applyTaxExclusionFlag = payComponentForm.js(jsSelectors.applyTaxExclusionFlag);
            var perPayLimit = payComponentForm.js(jsSelectors.perPayLimit);
            var annualLimit = payComponentForm.js(jsSelectors.annualLimit);
            var lifetimeLimit = payComponentForm.js(jsSelectors.lifetimeLimit);
            var perPayLimitHidden = payComponentForm.js(jsSelectors.perPayLimitHidden);
            var annualLimitHidden = payComponentForm.js(jsSelectors.annualLimitHidden);
            var lifetimeLimitHidden = payComponentForm.js(jsSelectors.lifetimeLimitHidden);
            var colaBankPercent = payComponentForm.js(jsSelectors.colaBankPercent);
            var percentCalculationContainer = payComponentForm.js(jsSelectors.percentCalculationContainer);
            var adjustmentCategorySelectors = percentCalculationContainer.js(jsSelectors.adjustmentCategorySelectors);
            var balanceParameterEditor = percentCalculationContainer.js(jsSelectors.balanceParameterEditor);
            var balanceParameterSelectors = balanceParameterEditor.js(jsSelectors.balanceParameterSelectors, { multiple: true });
            var balanceParameterSelectHelper = selectHelper.getHelper(balanceParameterSelectors);
            var balanceParameterGrid = percentCalculationContainer.js(jsSelectors.balanceParameterGrid);
            var includePensionFlag = payComponentForm.js(jsSelectors.includePensionFlag, { multiple: true });
            var includeAnnuityFlag = payComponentForm.js(jsSelectors.includeAnnuityFlag, { multiple: true });
            var includeDeductionsFlag = payComponentForm.js(jsSelectors.includeDeductionsFlag, { multiple: true });
            var includeSupplementsFlag = payComponentForm.js(jsSelectors.includeSupplementsFlag, { multiple: true });
            var payComponentMethod = payComponentForm.js(jsSelectors.payComponentMethod);
            var individualVendorFlag = payComponentForm.js(jsSelectors.individualVendorFlag);
            
            payComponentType.change(function () {
                payComponentSelectHelper.setValue(null);
                vendorSelectHelper.setValue(null);
                vendorSelectHidden.val(null);
                if (payComponentType.val()) {
                    payComponentSelectHelper.loadOptionsFrom(
                        backendUrls.getDefinedAvailablePayComponentsBackendUrl,
                        {
                            fundKey: fundKey,
                            payComponentType: payComponentType.val()
                        },
                        {
                            withBlank: true
                        });
                } else {
                    payComponentSelectHelper.clearOptions();
                    payComponentChanged();
                }
            });
            
            payComponent.change(payComponentChanged);

            //set and disable various controls after changing the selected pay component
            function payComponentChanged() {
                resetControls();

                $.getJSON(backendUrls.getSelectedPayComponentBackendUrl,
                    {
                        availablePayComponentKey: payComponent.val(),
                        fundKey: fundKey
                    }).done(function (data) {
                        var isStandardMethod = data.payComponentMethod == codeValues.standardMethod;
                        payComponentMethod.val(data.payComponentMethod);
                        componentAmount.prop('disabled', isStandardMethod || componentPercent.val());
                        componentPercent.prop('disabled', isStandardMethod || componentAmount.val());
                        applyPriorToTaxFlag.prop('disabled', isStandardMethod);
                        applyTaxExclusionFlag.prop('disabled', isStandardMethod);
                        individualVendorFlag.val(data.individualVendorFlag);
                        if (payComponent.val()) {
                            applyPriorToTaxFlag.prop('checked', data.applyPriorToTaxFlag);
                            applyTaxExclusionFlag.prop('checked', data.applyTaxExclusionFlag);
                        } else {
                            applyPriorToTaxFlag.prop('checked', false);
                            applyTaxExclusionFlag.prop('checked', false);
                        }

                        perPayLimit.prop('disabled', isStandardMethod);
                        annualLimit.prop('disabled', isStandardMethod);
                        lifetimeLimit.prop('disabled', isStandardMethod);
                        perPayLimitHidden.prop('disabled', !isStandardMethod);
                        annualLimitHidden.prop('disabled', !isStandardMethod);
                        lifetimeLimitHidden.prop('disabled', !isStandardMethod);

                        percentCalculationContainer.find(":input:not([type=hidden])").each(function () {
                            $(this).prop('disabled', isStandardMethod);
                        });
                        percentCalculationContainer.find(":input[type=hidden]").each(function () {
                            $(this).prop('disabled', !isStandardMethod);
                        });

                        if (isStandardMethod) {
                            perPayLimit.val(data.perPayLimitAmount);
                            annualLimit.val(data.annualLimitAmount);
                            lifetimeLimit.val(data.lifetimeLimitAmount);
                            perPayLimitHidden.val(data.perPayLimitAmount);
                            annualLimitHidden.val(data.annualLimitAmount);
                            lifetimeLimitHidden.val(data.lifetimeLimitAmount);

                            includePensionFlag.prop('checked', data.includePensionFlag );
                            includeAnnuityFlag.prop('checked', data.includeAnnuityFlag);
                            includeDeductionsFlag.prop('checked', data.includeDeductionsFlag);
                            includeSupplementsFlag.prop('checked', data.includeSupplementsFlag);
                            includePensionFlag.val(data.includePensionFlag);
                            includeAnnuityFlag.val(data.includeAnnuityFlag);
                            includeDeductionsFlag.val(data.includeDeductionsFlag);
                            includeSupplementsFlag.val(data.includeSupplementsFlag);
                                                        
                            $.getJSON(backendUrls.getComponentRateHistoryBackendUrl,
                                {
                                    availablePayComponentKey: payComponent.val()
                                }).done(function (data) {
                                    componentPercent.val(data.ratePercent).clearErrors();
                                    componentAmount.val(data.rateAmount).clearErrors();
                                    visibility.show(standardWarning);
                                    visibility.hide(standardWarningPlaceholder);
                                });
                            
                            gridModule.update(
                                backendUrls.getBalanceParametersBackendUrl,
                                {
                                    componentAmount: componentAmount.val(),
                                    componentPercent: componentPercent.val(),
                                    availablePayComponentKey: payComponent.val(),
                                    payComponentMethod: codeValues.standardMethod
                                },
                                balanceParametersGridLrsApi.agGridApi,
                                function done() {
                                    visibility.show(adjustmentCategorySelectors);
                                    visibility.hide(balanceParameterEditor);
                                    visibility.show(balanceParameterGrid);
                                }
                            );

                        } else {
                            visibility.hide(standardWarning);
                            visibility.show(standardWarningPlaceholder);
                            visibility.hide(adjustmentCategorySelectors);
                        }

                        if (!payComponent.val()) {
                            vendorSelectHelper.setValue(null);
                            vendorSelectHidden.val(null);
                        }
                        else if (data.payComponentType == codeValues.deduction) {
                            vendorSelectHelper.setValue(data.vendorPartyKey);
                            vendorSelectHelper.setDisabled(!data.individualVendorFlag);
                            vendorSelectHidden.val(data.vendorPartyKey);
                            vendorSelectHidden.prop('disabled', data.individualVendorFlag);
                        }

                        var typeIsAdjustment = data.payComponentType == codeValues.adjustment;
                        if (!typeIsAdjustment || codeValues.cola != data.adjustmentCategory) {
                            colaBankPercent.val("0.00000%");
                            colaBankPercent.prop('disabled', true);
                        }
                        if (typeIsAdjustment && codeValues.cola == data.adjustmentCategory) {
                            colaBankPercent.val(null);
                            colaBankPercent.prop('disabled', false);
                        }
                    });
            }

            // Reset controls after changing the selected pay component 
            function resetControls() {
                vendorSelectHelper.setValue(null);
                vendorSelectHelper.setDisabled(true);
                vendorSelectHidden.val(null);
                vendorSelectHidden.prop('disabled',true);
                componentAmount.val(null);
                componentPercent.val(null);
                applyPriorToTaxFlag.prop('checked', false);
                applyTaxExclusionFlag.prop('checked', false);

                perPayLimit.val(null);
                annualLimit.val(null);
                lifetimeLimit.val(null);
                perPayLimitHidden.val(null);
                annualLimitHidden.val(null);
                lifetimeLimitHidden.val(null);

                colaBankPercent.val("0.00000%");
                colaBankPercent.prop('disabled', true);

                percentCalculationContainer.find(":input:not([type=hidden])").each(function () {
                    $(this).prop('disabled', false);
                });
                percentCalculationContainer.find(":input[type=hidden]").each(function () {
                    $(this).prop('disabled', true);
                });
            }

            componentAmount.change(function () {
                componentPercent.prop('disabled', componentAmount.val());
                percentCalculationContainer.prop('disabled', componentAmount.val());
                if (componentAmount.val()) {
                    percentCalculationContainer.find(":input:not([type=hidden])").each(function () {
                        $(this).prop('disabled', true);
                    });
                    percentCalculationContainer.find(":input[type=hidden]").each(function () {
                        $(this).prop('disabled', false);
                    });
                    
                    includePensionFlag.prop('checked', false);
                    includeAnnuityFlag.prop('checked', false);
                    includeDeductionsFlag.prop('checked', false);
                    includeSupplementsFlag.prop('checked', false);

                    visibility.hide(adjustmentCategorySelectors);
                } else {
                    percentCalculationContainer.find(":checkbox").each(function () {
                        $(this).prop('disabled', false);
                    });
                    visibility.hide(adjustmentCategorySelectors);
                    visibility.hide(balanceParameterEditor);
                    visibility.hide(balanceParameterGrid);
                }
            });

            componentPercent.change(function () {
                var previouslyHadValue = componentAmount.prop('disabled');
                componentAmount.prop('disabled', componentPercent.val());
                percentCalculationContainer.prop('disabled', componentPercent.val());
                if (componentPercent.val()) {
                    percentCalculationContainer.find(":input:not([type=hidden])").each(function () {
                        $(this).prop('disabled', false);
                    });
                    percentCalculationContainer.find(":input[type=hidden]").each(function () {
                        $(this).prop('disabled', true);
                    });
                    visibility.show(adjustmentCategorySelectors);
                    visibility.show(balanceParameterEditor);
                    visibility.hide(balanceParameterGrid);

                    $.getJSON(backendUrls.getSelectedPayComponentBackendUrl,
                        {
                            availablePayComponentKey: payComponent.val(),
                            fundKey: fundKey
                        }).done(function (data) {
                            includePensionFlag.prop('checked', data.includePensionFlag);
                            includeAnnuityFlag.prop('checked', data.includeAnnuityFlag);
                            includeDeductionsFlag.prop('checked', data.includeDeductionsFlag);
                            includeSupplementsFlag.prop('checked', data.includeSupplementsFlag);
                            if (!previouslyHadValue) {
                                balanceParameterSelectHelper.setValue(data.individualPayComponentKeys);
                            }
                        });
                }
                else {
                    visibility.hide(adjustmentCategorySelectors);
                    visibility.hide(balanceParameterEditor);
                    visibility.hide(balanceParameterGrid);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);